import { ethers } from 'ethers';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import { getCatDetails, getWrappedId } from '../lib';
import Mooncat from './Mooncat';

function OpenSea({ tokenId }) {
  return (
    <a target="_blank" href={`https://opensea.io/assets/0x7c40c393dc0f283f318791d746d894ddd3693572/${tokenId}?ref=0x6efef34e81fd201edf18c7902948168e9ebb88ae`} >
      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 2 }}>
        <img src="https://files.readme.io/566c72b-opensea-logomark-full-colored.png" style={{ width: '1.9rem' }} />
        OpenSea
      </div>
    </a>
  )
}

export default function CatDetails() {

  let { catId } = useParams();
  const [catDetails, setCatDetails] = useState(undefined)

  const [catName, setCatName] = useState(undefined)
  const [wrappedId, setWrappedId] = useState(undefined)

  useEffect(() => {

    getCatDetails(catId)
    .then(details => setCatDetails(details))
    .catch(err => console.log('error', err))
    
    return () => {
    }
  }, [])

  useEffect(() => {
    
    if(!catDetails) {
      return
    }

    let catName = catDetails.name === '0x0000000000000000000000000000000000000000000000000000000000000000' ? '<unnamed>' : ethers.utils.parseBytes32String(catDetails.name)
    setCatName(catName)

    if(catDetails.owner.toLowerCase() === '0x7C40c393DC0f283F318791d746d894DdD3693572'.toLowerCase()) {
      getWrappedId(catId)
      .then(tokenId => setWrappedId(tokenId))
      .catch(err => console.log('error', err))
    }

    return () => {
      
    }
  }, [catDetails])

  return (
    <div>
      <div style={{ display: 'flex'}}>
        <Mooncat catId={catId} details={false} name={ catName} />
        {catDetails && <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2rem' }}>
          <div>ID: {catDetails.id}</div>
          <div>Name: { catName }</div>
          <div>Owner: {catDetails.owner}</div>
          <div>Wrapped (ERC721): {catDetails.owner.toLowerCase() === '0x7C40c393DC0f283F318791d746d894DdD3693572'.toLowerCase() ? 'true' : 'false' } </div>
          <div style={{ display: 'flex' , alignItems: 'center'}}>Buy: {wrappedId ? <OpenSea tokenId={wrappedId} /> : 'Not available'} </div>
        </div>
        }
      </div>

    </div>
  )
}
